export default "<es-uber-freight-forget-password-page></es-uber-freight-forget-password-page>\n"